import {
  SET_MY_QUESTS_FILTER,
  SET_MY_QUESTS_SORT,
  FETCH_MY_QUESTS_REQUEST,
  FETCH_MY_QUESTS_FAILURE,
  FETCH_MY_QUESTS_SUCCESS,
  CLEAR_MY_QUESTS
} from '../actions/myquests'

import { SET_CURRENT_ORGANIZATION } from '../actions/organization'

const initialState = {
  filter: 'drafts',
  sort: 'updated_at desc',
  quests: [],
  isFetchingQuests: false,
  page: null,
  total: null
}

export function myquests(state = initialState, action) {
  switch (action.type) {
    case SET_MY_QUESTS_FILTER: {
      return Object.assign({}, state, {
        filter: action.filter
      })
    }

    case SET_MY_QUESTS_SORT: {
      return Object.assign({}, state, {
        sort: action.sort
      })
    }

    case FETCH_MY_QUESTS_REQUEST: {
      return Object.assign({}, state, {
        isFetchingQuests: true
      })
    }

    case FETCH_MY_QUESTS_SUCCESS: {
      let quests = []
      Object.assign(quests, state.quests)

      action.payload.quests.forEach(function (item) {
        quests.push(item)
      })

      const idPositions = quests.map(item => item.id)
      const newPayload = quests.filter((item, pos, arr) => {
        return idPositions.indexOf(item.id) === pos
      })

      return Object.assign({}, state, {
        isFetchingQuests: false,
        quests: newPayload,
        page: action.payload.page,
        total: action.payload.total
      })
    }

    case FETCH_MY_QUESTS_FAILURE: {
      return Object.assign({}, state, {
        isFetchingQuests: false,
        quests: [],
        page: null,
        total: null
      })
    }

    case CLEAR_MY_QUESTS: {
      return Object.assign({}, state, {
        quests: [],
        page: null,
        total: null
      })
    }

    case SET_CURRENT_ORGANIZATION: {
      return Object.assign({}, state, {
        quests: [],
        page: null,
        total: null
      })
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/myquests.js